import { DriveFile } from '@/modules/drive/domain/models/DriveFile'

import { axios, Response } from '../index'

export default async function getPersonaFiles(
  personId: string
): Response<DriveFile[]> {
  return await axios.get(`/v1/personas/${personId}/files`)
}
